import React, { Component, Fragment } from "react";
import { withRouter, Switch, Route } from "react-router-dom";
import PropTypes from "prop-types";

import AdminRoutes from "./AdminRoutes";
import IssuerRoutes from "./IssuerRoutes";
import StoreRoutes from "./StoreRoutes";
import ManagerRoutes from "./ManagerRoutes";
import ChargeManagerRoutes from "./ChargeManagerRoutes";
import LoggedOutRoutes from "./LoggedOutRoutes";
import { getViewType } from "./viewType";
import FeeTaxForm from "../Routes/FeeTaxForm/index";
import DonationTaxForm from "../Routes/DonationTaxForm/index";

class PageRoute extends Component {
  constructor(props) {
    super(props);
    this.previousLocation = this.props.location;
  }

  UNSAFE_componentWillUpdate() {
    let { location } = this.props;

    if (!(location.state && location.state.modal)) {
      this.previousLocation = location;
    }
  }

  render() {
    const { userData, isLoggedIn, history, location, match } = this.props;
    const isModal =
      location.state &&
      location.state.modal &&
      this.previousLocation !== location;
    // 회비/기부 주민번호 수집 공개 폼은 로그인 여부와 무관하게 접근 가능
    if (location.pathname.startsWith("/fee-tax-info/")) {
      return (
        <Switch>
          <Route exact path="/fee-tax-info/:token" component={FeeTaxForm} />
        </Switch>
      );
    }
    if (location.pathname.startsWith("/donation-tax-info/")) {
      return (
        <Switch>
          <Route
            exact
            path="/donation-tax-info/:token"
            component={DonationTaxForm}
          />
        </Switch>
      );
    }
    // 로그인 시 선택한 유형(권한 검증 통과) 기준으로 화면을 가른다.
    const viewType = getViewType(userData.AdminInfo);
    return isLoggedIn ? (
      <Fragment>
        {viewType === "Administrator" && (
          <AdminRoutes
            userData={userData}
            history={history}
            location={location}
            match={match}
            isModal={isModal}
            previousLocation={this.previousLocation}
          />
        )}
        {viewType === "Issuer" && (
          <IssuerRoutes
            userData={userData}
            history={history}
            location={location}
            match={match}
            isModal={isModal}
            previousLocation={this.previousLocation}
          />
        )}
        {viewType === "Manager" && (
          <ManagerRoutes
            userData={userData}
            history={history}
            location={location}
            match={match}
            isModal={isModal}
            previousLocation={this.previousLocation}
          />
        )}
        {viewType === "ChargeManager" && (
          <ChargeManagerRoutes
            userData={userData}
            history={history}
            location={location}
            match={match}
            isModal={isModal}
            previousLocation={this.previousLocation}
          />
        )}
        {viewType === "Store" && (
          <StoreRoutes
            userData={userData}
            history={history}
            location={location}
            match={match}
            isModal={isModal}
            previousLocation={this.previousLocation}
          />
        )}
      </Fragment>
    ) : (
      <LoggedOutRoutes />
    );
  }
}

PageRoute.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

export default withRouter(PageRoute);
